<script lang="ts" setup>
const props = defineProps({
  block: {
    default: false,
    type: Boolean,
  },
  color: {
    default: 'gray',
    type: String as PropType<UButtonColor>,
  },
  size: {
    default: 'sm',
    type: String as PropType<UButtonSize>,
  },
  type: {
    default: 'chatWithUs',
    type: String as PropType<ButtonChatType>,
  },
  variant: {
    default: 'solid',
    type: String as PropType<UButtonVariant>,
  },
})

const emit = defineEmits<{
  click: []
}>()

const { t } = useI18n()

const label = computed(() => {
  switch (props.type) {
    case 'askQuestions':
      return t('askQuestions')

    case 'requestFeature':
      return t('requestFeature')

    default:
      return t('chatWithUs')
  }
})

function onClick() {
  toggleChatbox('open')

  emit('click')
}
</script>

<template>
  <UButton
    :block="block"
    :color="color"
    :icon="getIcon('supportChat')"
    :label="label"
    :size="size"
    :ui="{ icon: { base: 'text-indigo-400 dark:text-indigo-600' } }"
    :variant="variant"
    @click="onClick"
  />
</template>

<i18n lang="json">
{
  "en": {
    "askQuestions": "Questions? Ask us!",
    "chatWithUs": "Chat with us",
    "requestFeature": "Request a feature"
  },
  "es": {
    "askQuestions": "¿Preguntas? ¡Preguntanos!",
    "chatWithUs": "Chatea con nosotros",
    "requestFeature": "Solicitar una función"
  },
  "fr": {
    "askQuestions": "Des questions ? Posez-les-nous !",
    "chatWithUs": "Discuter avec nous",
    "requestFeature": "Demander une fonctionnalité"
  }
}
</i18n>
